import { DatePipe } from '@angular/common';

/** API `chatTitle` like `08-04-2026 19:52` as UTC wall time → local display.
 *  Remove when BE sends the final title.
 */
const CHAT_TITLE_UTC_WALL_CLOCK = /^(\d{2})-(\d{2})-(\d{4})\s+(\d{2}):(\d{2})$/;

export function formatAiChatThreadListTitle(
  title: string | null | undefined,
  datePipe: DatePipe,
): string {
  if (title == null || title === '') {
    return '';
  }

  const trimmed = title.trim();
  const match = CHAT_TITLE_UTC_WALL_CLOCK.exec(trimmed);

  if (!match) {
    return trimmed;
  }

  const [, day, month, year, hours, minutes] = match;
  const utcMs = Date.UTC(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hours),
    Number(minutes),
  );
  const date = new Date(utcMs);

  if (Number.isNaN(date.getTime())) {
    return trimmed;
  }

  return datePipe.transform(date, 'dd.MM.yyyy HH:mm') ?? trimmed;
}
